<template>
  <section class="p-destinationSection" :id="destination.acf.dest_name">
    <color-overlay 
      :offset="0.5" 
      class="p-destinationSection__eyecatch js-navigation-switch">
      <!-- 処理を挟みたいのでaタグにしています -->
      <a :href="`/destination/${destination.slug}`" 
        class="p-destinationSection__picture"
        @click.prevent="onClickLink" 
        @mouseenter="onMouseEnter">
        <img :src="destination.acf.main_image.url" alt="" class="u-cover" ref="coverImage">
        <img :src="destination.acf.main_image.url" ref="mainImage" alt="" style="display: none;">
      </a>
    </color-overlay>

    <scroll-animation-unit class="p-destinationSection__content">
      <div class="p-destinationSection__header">
        <!-- 処理を挟みたいのでaタグにしています -->
        <a :href="`/destination/${destination.slug}`" 
          class="p-destinationSection__link"
          @click.prevent="onClickLink" 
          @mouseenter="onMouseEnter">
          <div class="u-mask">
            <h3 
              class="p-destinationSection__heading" 
              :style="{
                'color': color,
                'background-image': backgroundImage
              }">{{ destination.acf.dest_name }}</h3>  
          </div>
          <em class="p-destinationSection__prefecture"><span class="u-mask">{{ destination.acf.dest_pref }}</span></em>
        </a>
      </div>
      <div class="p-destinationSection__main">
        <picture class="p-destinationSection__map">
          <img :src="destination.acf.dest_image.url" alt="">
        </picture>
        <p class="p-destinationSection__lead"><span class="u-mask" v-html="destination.acf.dest_top_lead"></span></p>
        <p class="p-destinationSection__text u-fade" v-html="destination.acf.dest_lead"></p>
        
        
        <!-- <a href="#" 
          @click.prevent="onClickLink" 
          @mouseenter="onMouseEnter" 
          class="c-transitionButton p-destinationSection__button u-fade" 
          data-type="default">
          <span class="c-transitionButton__inner">Accommodation in this Area</span>
        </a> -->

        <ul class="p-destinationSection__buttons">
          <li class="u-fade">
            <a 
              :href="`/destination/${destination.slug}`" 
              class="c-transitionButton p-destinationSection__button" 
              data-type="default" 
              data-size="default"
              @click.prevent="onClickLink" 
              @mouseenter="onMouseEnter">
              <span class="c-transitionButton__inner">More Detail</span></a>
          </li>
          
          <li class="u-fade">
            <transition-button :to="`/destination/${destination.slug}/#accommodation`" size="small">Our Accommodation</transition-button>
          </li>
        </ul>
      </div>
    </scroll-animation-unit>
  </section>
</template>

<script>
  /**
   * Modules
   */
  import { mapGetters, mapMutations } from 'vuex'
  import imagesLoaded from 'imagesloaded'
  import SweetScroll from 'sweet-scroll'
  import 'rgbaster'

  import TransitionButton from '~/partial/transition-button'

  import navigationSwitch from '~/mixins/navigation-switch'

  /**
   * Share Partial
   */

  export default {
    name: 'destination-section',
    mixins: [navigationSwitch],
    components: {
      TransitionButton
    },
    data() {
      return {
        backgroundImage: '',
        color: 'transparent',
        scroller: null,
      }
    },
    props: {
      destination: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        'coverImageId': 'coverImage/id',
        'isScaled': 'coverImage/isScaled',
      })
    },
    watch: {
      isScaled(value) {
        if(this.destination.id === this.coverImageId) {
          if(value) {
            this.$router.push(`/destination/${this.destination.slug}`)
          }  
        }
      }
    },
    created() {
      // eslint-disable-next-line no-new
      this.scroller = new SweetScroll({
        duration: 400,
        easing: 'easeOutSine',
        after: this.onScrollAfter
      })
    },
    mounted() {
      this.$nextTick(() => {
        imagesLoaded(this.$el, this.onImageLoaded)
      })
    },
    methods: {
      getBackgroundImage(imageEl) {
        let backgroundImage = imageEl.getAttribute('src')
        return `url(${backgroundImage})`
      },
      onImageLoaded() {
        this.backgroundImage = this.getBackgroundImage(this.$refs.mainImage)

        global.RGBaster.colors(this.$refs.mainImage, {
          exclude: [
            'rgb(255,255,255)',
            'rgb(0,0,0)',
          ],
          success: (payload) => {
            this.color = payload.dominant
          }
        })
      },
      onMouseEnter() {
        this.setId(this.destination.id)
        this.setSrc(this.destination.acf.main_image.url)
        this.setDestName(this.destination.acf.dest_name)
      },
      onClickLink() {
        // 1. クリックで画像が一番上に来るように移動(移動後に onScrollAfter が発火)
        this.$nextTick(() => {
          this.scroller.to(`#${this.destination.acf.dest_name}`)  
        })
      },
      onScrollAfter() {
        let image = this.$refs.coverImage

        // 2. 位置取得
        let { width, height, top, left } = image.getBoundingClientRect()

        // 3. サイズ、位置をセット
        this.setSize({ width, height })
        this.setPosition({ top, left })

        // 4. セット完了をstoreに伝える
        this.$nextTick(() => {
          this.setCoverImageFixedState(true)  
        })

        // 5. 拡大開始(cover-image.vueにて実装)
        // 6. 拡大が完了後に遷移(isScaledをwatch)
      },
      ...mapMutations({
        'setId': 'coverImage/SET_ID',
        'setSrc': 'coverImage/SET_SRC',
        'setDestName': 'coverImage/SET_DEST_NAME',
        'setSize': 'coverImage/SET_SIZE',
        'setPosition': 'coverImage/SET_POSITION',
        'setCoverImageFixedState': 'coverImage/SET_FIXED_STATE'
      }),
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/destination-section.vue